<template>
  <div class="">
    <!-- Section 3 -->
    <tl-accordion headerName="Section 10">
      <div slot="accordionBody">
        <div class="container-fluid my-2">
          <data-table
            :columns="tableColumnsSection10"
            :tableData="section10List"
            :checkbox="false"
            :withForm="false"
            :showinrow="true"
            :showmodal="true"
            :showedit="false"
            :showdelete="false"
            :showhistory="false"
            @modalShow="modalSection10"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <p v-if="slotprops.value.column.key == 'slno'">
                  {{ slotprops.value.index + 1 }}
                </p>
                <p v-if="slotprops.value.column.key == 'particulars'">
                  {{
                    slotprops.value.record.InvestmentComponentType
                      ? slotprops.value.record.InvestmentComponentType.name
                      : slotprops.value.record.name
                  }}
                </p>
                <p v-if="slotprops.value.column.key == 'limits'">
                  ₹
                  {{
                    slotprops.value.record.InvestmentComponentType
                      ? slotprops.value.record.InvestmentComponentType
                          .maximumAmount
                      : Object.keys(slotprops.value.record.rule).length
                      ? slotprops.value.record.rule.maximum_limit
                      : null
                  }}
                </p>
                <!-- <p v-if="slotprops.value.column.key=='planned'">
                                    <txt
                                      type="number"
                                      :disable="true"
                                      :name="'explannedvalue'+slotprops.value.index"
                                      v-model="section10List[slotprops.value.index].planned"
                                    />
                                  </p> -->
                <p v-if="slotprops.value.column.key == 'actual'">
                  ₹ {{ section10List[slotprops.value.index].actual }}
                  <!-- <txt
                                      v-if="slotprops.value.record[slotprops.value.column.key] != null"
                                      type="number"
                                      :disable="false"
                                      :name="'exactualvalue'+slotprops.value.index"
                                      v-model="section10List[slotprops.value.index].actual"
                                    />
                                    <span v-else>-</span> -->
                </p>
                <p v-if="slotprops.value.column.key == 'file_location'">
                  <a
                    href="javascript:void(0)"
                    v-if="slotprops.value.record['file_location']"
                    @click="
                      openDocModal(
                        section10List[slotprops.value.index].file_location,
                        ''
                      )
                    "
                    ><img
                      class="atch-img"
                      :src="require('@/assets/ic-attachment.png')"
                    />
                    {{ slotprops.value.record["file_location"].length }}
                    attachment</a
                  >
                  <span v-else>-</span>
                </p>
                <div
                  class="action-section"
                  v-if="slotprops.value.column.key == 'action'"
                >
                  <img
                    src="@/assets/group-2.png"
                    class="pointer-cursor"
                    @click="dropdown(slotprops.value.record)"
                    alt="actionIcon"
                  />
                  <ul
                    class="action-menu"
                    v-show="section10List[slotprops.value.index].showDropDown"
                  >
                    <li>
                      <span class @click="approve(slotprops.value.record)"
                        >Approve</span
                      >
                    </li>
                    <li>
                      <span
                        class
                        @click="partiallyApprove(slotprops.value.record)"
                        >Partially Approve</span
                      >
                    </li>
                    <li>
                      <span class @click="reject(slotprops.value.record)"
                        >Reject</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </tl-accordion>
    <!-- end section 3 -->

    <!-- Section 4 -->
    <!-- first comment section start by bhushan -->
    <!--<tl-accordion headerName="Section 17">
      <div slot="accordionBody">
        <div class="container-fluid mt-3 mb-2">
          <data-table
            :columns="tableColumnsSection17"
            :tableData="section17List"
            :checkbox="false"
            :withForm="false"
            :showinrow="true"
            :showmodal="true"
            :showedit="false"
            :showdelete="false"
            :showhistory="false"
            @modalShow="modalSection17"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <p v-if="slotprops.value.column.key == 'slno'">
                  {{ slotprops.value.index + 1 }}
                </p>
                <p v-if="slotprops.value.column.key == 'particulars'">
                  {{
                    slotprops.value.record.InvestmentComponentType
                      ? slotprops.value.record.InvestmentComponentType.name
                      : slotprops.value.record.name
                  }}
                </p>
                <p v-if="slotprops.value.column.key == 'limits'">
                  ₹
                  {{
                    slotprops.value.record.InvestmentComponentType
                      ? slotprops.value.record.InvestmentComponentType
                          .maximumAmount
                      : Object.keys(slotprops.value.record.rule).length
                      ? slotprops.value.record.rule.maximum_limit
                      : null
                  }}
                </p>-->
                <!-- first comment section end by bhushan -->
                <!-- <p v-if="slotprops.value.column.key=='planned'">
                                    <txt
                                      type="number"
                                      :disable="true"
                                      :name="'explannedvalue'+slotprops.value.index"
                                      v-model="section17List[slotprops.value.index].planned"
                                    />
                                     <span v-else>-</span> 
                                  </p> -->
                <!-- Second comment section start by bhushan -->
                <!--<p v-if="slotprops.value.column.key == 'actual'">
                  ₹ {{ section17List[slotprops.value.index].actual }}-->
                <!-- Second comment section end by bhushan -->  
                  <!-- <txt
                                      v-if="slotprops.value.record[slotprops.value.column.key] != null"
                                      type="number"
                                      :disable="false"
                                      :name="'exactualvalue'+slotprops.value.index"
                                      v-model="section17List[slotprops.value.index].actual"
                                    />
                                    <span v-else>-</span> -->
                <!-- Third comment section start by bhushan -->
                <!-- </p>
                <p v-if="slotprops.value.column.key == 'file_location'">
                  <a
                    href="javascript:void(0)"
                    v-if="slotprops.value.record['file_location']"
                    @click="
                      openDocModal(
                        section17List[slotprops.value.index].file_location,
                        ''
                      )
                    "
                    ><img
                      class="atch-img"
                      :src="require('@/assets/ic-attachment.png')"
                    />
                    {{ slotprops.value.record["file_location"].length }}
                    attachment</a
                  >
                  <span v-else>-</span>
                </p>
                <div
                  class="action-section"
                  v-if="slotprops.value.column.key == 'action'"
                >
                  <img
                    src="@/assets/group-2.png"
                    class="pointer-cursor"
                    @click="dropdown2(slotprops.value.record)"
                    alt="actionIcon"
                  />
                  <ul
                    class="action-menu"
                    v-show="section17List[slotprops.value.index].showDropDown"
                  >
                    <li>
                      <span class @click="approve(slotprops.value.record)"
                        >Approve</span
                      >
                    </li>
                    <li>
                      <span
                        class
                        @click="partiallyApprove(slotprops.value.record)"
                        >Partially Approve</span
                      >
                    </li>
                    <li>
                      <span class @click="reject(slotprops.value.record)"
                        >Reject</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </tl-accordion> -->
    <!-- Third comment section end by bhushan -->
    <!-- end section 4 -->

    <!-- Section 5 -->
    <tl-accordion headerName="80C (Chapter VI A)">
      <div slot="accordionBody">
        <div class="container-fluid mt-3 mb-2">
          <data-table
            :columns="tableColumns80C"
            :tableData="data80CList"
            :withForm="false"
            :showinrow="true"
            :showmodal="true"
            :showedit="false"
            :showdelete="false"
            :showhistory="false"
            @modalShow="modalChapterVIA"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <p v-if="slotprops.value.column.key == 'slno'">
                  {{ slotprops.value.index + 1 }}
                </p>
                <p v-if="slotprops.value.column.key == 'particulars'">
                  {{
                    slotprops.value.record.InvestmentComponentType
                      ? slotprops.value.record.InvestmentComponentType.name
                      : slotprops.value.record.name
                  }}
                </p>
                <p v-if="slotprops.value.column.key == 'limits'">
                  ₹
                  {{
                    slotprops.value.record.InvestmentComponentType
                      ? slotprops.value.record.InvestmentComponentType
                          .maximumAmount
                      : Object.keys(slotprops.value.record.rule).length
                      ? slotprops.value.record.rule.maximum_limit
                      : null
                  }}
                </p>
                <!-- <p v-if="slotprops.value.column.key=='planned'">
                                    <txt
                                      type="number"
                                      :disable="true"
                                      :name="'explannedvalue'+slotprops.value.index"
                                      v-model="data80CList[slotprops.value.index].planned"
                                    />
                                     <span v-else>-</span> 
                                  </p> -->
                <p v-if="slotprops.value.column.key == 'actual'">
                  ₹ {{ data80CList[slotprops.value.index].actual }}
                  <!-- <txt
                                      v-if="slotprops.value.record[slotprops.value.column.key] != null"
                                      type="number"
                                      :disable="false"
                                      :name="'exactualvalue'+slotprops.value.index"
                                      v-model="data80CList[slotprops.value.index].actual"
                                    />
                                    <span v-else>-</span> -->
                </p>
                <p v-if="slotprops.value.column.key == 'file_location'">
                  <a
                    href="javascript:void(0)"
                    v-if="slotprops.value.record['file_location']"
                    @click="
                      openDocModal(
                        data80CList[slotprops.value.index].file_location,
                        ''
                      )
                    "
                    ><img
                      class="atch-img"
                      :src="require('@/assets/ic-attachment.png')"
                    />
                    {{ slotprops.value.record["file_location"].length }}
                    attachment</a
                  >
                  <span v-else>-</span>
                </p>
                <div
                  class="action-section"
                  v-if="slotprops.value.column.key == 'action'"
                >
                  <img
                    src="@/assets/group-2.png"
                    class="pointer-cursor"
                    @click="dropdown3(slotprops.value.record)"
                    alt="actionIcon"
                  />
                  <ul
                    class="action-menu"
                    v-show="data80CList[slotprops.value.index].showDropDown"
                  >
                    <li>
                      <span class @click="approve(slotprops.value.record)"
                        >Approve</span
                      >
                    </li>
                    <li>
                      <span
                        class
                        @click="partiallyApprove(slotprops.value.record)"
                        >Partially Approve</span
                      >
                    </li>
                    <li>
                      <span class @click="reject(slotprops.value.record)"
                        >Reject</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <!-- <template v-slot:rowcontent="slotprops">
                          <p
                          v-if="slotprops.value.column.key === 'particulars'"
                          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                          <p
                          v-if="slotprops.value.column.key ==='yearly_limit'"
                          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                          <p
                          v-if="slotprops.value.column.key ==='planned_investment'"
                          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                          <p v-if="slotprops.value.column.key=='actual_investment'">
                          <txt
                            type="number"
                            :disable="true"
                            :name="'oivalue'+slotprops.value.index"
                            v-model="data80CList[slotprops.value.index].actual"
                          />
                        </p>
                        <p v-if="slotprops.value.column.key == 'proofs_attachment'">
                          <a
                            href="javascript:void(0)"
                            v-if="slotprops.value.record[slotprops.value.column.key]"
                            @click="openDocModal80C(slotprops.value)"
                          ><img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
                          <span class="attachment-text">{{slotprops.value.record[slotprops.value.column.key].length }} attachment</span>
                          </a>
                        </p>
                      </template> -->
          </data-table>
        </div>
      </div>
    </tl-accordion>
    <!-- end section 5 -->

    <tl-accordion>
      <template v-slot:accordionHeader>
        <div class="row">
          <div class="col-6">Section 24 (Housing Loan)</div>
          <div class="col-6 align-right"></div>
        </div>
      </template>
      <template v-slot:accordionBody>
        <div class="datatable-outer-container">
          <table class="datatable">
            <thead>
              <tr class="header-row">
                <th>(i)Interest on housing loan (Self occupied)</th>
                <th>Planned</th>
                <th>Actual</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tr
              v-for="(item, index) in section24.self_occupied.selfOccupied"
              :key="index"
              class="record-row"
            >
              <td>{{ item.name }}</td>
              <td>
                <txt
                  type="number"
                  :name="'soplanned' + index"
                  :disable="true"
                  v-model="item.planned"
                />
              </td>
              <td>
                <txt
                  type="number"
                  :name="'soactual' + index"
                  v-model="item.actual"
                  @change="sumSelfOccupied()"
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr class="record-row">
              <td>
                <b>Total</b>
              </td>
              <td>
                <txt
                  type="number"
                  name="total_planned"
                  :disable="true"
                  v-model="section24.self_occupied.total_planned"
                />
              </td>
              <td>
                <txt
                  type="number"
                  name="total_actual"
                  :disable="true"
                  v-model="section24.self_occupied.total_actual"
                />
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  @click="
                    openDocModal(section24.self_occupied.proof, 'self-occupied')
                  "
                  >{{ section24.self_occupied.proof.length }} attachment</a
                >
              </td>
              <!-- <td>
                <label class="fileLabel" :for="'sfile' + 0">
                  <img src="@/assets/group-5.svg" class="plus-icon" />
                  <input
                    type="file"
                    :id="'sfile' + 0"
                    @change="
                      uploadFile($event.target.files[0], 0, 'Section24-self')
                    "
                  />
                </label>
              </td> -->
            </tr>
          </table>
        </div>
        <div class="d-payroll__accord margin-t-m">
          <div class="it-payroll__accordBlock">
            <div class="it_accordHeading d-heading">
              Self - Decaration for Joint Property
            </div>
            <div class="accordContent">
              <div class="row">
                <div class="col-12">
                  <div class="icon">
                    <div class="row">
                      <div class="col-4">
                        <txt
                          label="Name of Joint Holder"
                          name="joint_holder_name"
                          v-model="section24.self_occupied.joint_holder_name"
                        />
                      </div>
                    </div>
                    <div class="row margin-t-s">
                      <div class="col-4">
                        <txt
                          label="Relationship"
                          name="relationship"
                          v-model="section24.self_occupied.relationship"
                        />
                      </div>
                    </div>
                    <div class="row margin-t-s">
                      <div class="col-4 margin-t-s">
                        % of tax benefit claimed by joint Holder
                      </div>
                      <div class="col-4">
                        <txt
                          name="tax_benefit"
                          type="number"
                          v-model="section24.self_occupied.tax_benefit"
                        />
                      </div>
                    </div>
                    <div class="row margin-t-s">
                      <btn
                        class="btn-sm custom-btn-block"
                        text="Approve"
                        type="primary"
                        @click="selfoccupiedApprove('Self occupied')"
                      />
                      <btn
                        class="btn-sm custom-btn-block mx-2"
                        text="Partially Approve"
                        type="primary"
                        @click="selfoccupiedPartiallyApprove('Self occupied')"
                      ></btn>
                      <btn
                        class="btn-sm custom-btn-block"
                        text="Reject"
                        type="primary"
                        @click="selfoccupiedReject('Self occupied')"
                      ></btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(letout, index) in section24.let_out_property" :key="index">
          <div class="row">
            <div
              class="col-12 align-right"
              v-if="section24.let_out_property.length > 1"
            >
              <a class="delete-btn" @click="deleteLetOut(index)">
                <img src="@/assets/delete.svg" />
                <span>Delete LetOut Property</span>
              </a>
            </div>
          </div>
          <div class="datatable-outer-container">
            <table class="datatable">
              <thead>
                <tr class="header-row">
                  <th>(ii)Income/loss from house property (Letout)</th>
                  <th>Planned</th>
                  <th>Actual</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tr
                v-for="(item, idx) in letout.letOut"
                :key="idx"
                class="record-row"
              >
                <td>{{ item.name }}</td>
                <td>
                  <txt
                    type="number"
                    :name="'loplanned' + idx"
                    :disable="true"
                    v-model="item.planned"
                  />
                </td>
                <td>
                  <txt
                    type="number"
                    v-if="!item.isCalculate"
                    :name="'loactual' + idx"
                    v-model="item.actual"
                    @change="sumLetOutActual(index)"
                    :disable="item.isDisabled"
                  />
                  <txt
                    type="number"
                    v-else
                    :name="'loactual' + idx"
                    v-model="item.actual"
                    @change="
                      calculateOther(index, idx, item.name);
                      sumLetOutActual(index);
                    "
                    :disable="item.isDisabled"
                  />
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr class="record-row">
                <td>
                  <b>Total</b>
                </td>
                <td>
                  <txt
                    type="number"
                    :name="'totalletoutPlanned' + index"
                    :disable="true"
                    v-model="letout.total_planned"
                  />
                </td>
                <td>
                  <txt
                    type="number"
                    :name="'totalletoutActual' + index"
                    :disable="true"
                    v-model="letout.total_actual"
                  />
                </td>
                <td>
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(letout.proof, index, 'letout')"
                    >{{ letout.proof.length }} attachment</a
                  >
                </td>
                <!-- <td>
                  <label class="fileLabel" :for="'lfile' + index">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      :id="'lfile' + index"
                      @change="
                        uploadFile(
                          $event.target.files[0],
                          index,
                          'Section24-letout'
                        )
                      "
                    />
                  </label>
                </td> -->
              </tr>
            </table>
          </div>
          <div class="datatable-outer-container">
            <table class="datatable">
              <tbody>
                <tr class="record-row">
                  <td>
                    <b>Total Exemption</b>
                    <p>Either 2 Lakhs or (i+ii)</p>
                  </td>
                  <td>
                    <txt type="number" name="totalPlanned" :disable="true" />
                  </td>
                  <td>
                    <txt type="number" name="totalPlanned" :disable="true" />
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-payroll__accord margin-t-m">
            <div class="it-payroll__accordBlock">
              <div class="it_accordHeading d-heading">
                Self - Decaration for Joint Property
              </div>
              <div class="accordContent">
                <div class="row">
                  <div class="col-12">
                    <div class="icon">
                      <div class="row">
                        <div class="col-4">
                          <txt
                            label="Name of Joint Holder"
                            :name="'letout_joint_holder_name' + index"
                            v-model="letout.joint_holder_name"
                          />
                        </div>
                      </div>
                      <div class="row margin-t-s">
                        <div class="col-4">
                          <txt
                            label="Relationship"
                            :name="'letout_relationship' + index"
                            v-model="letout.relationship"
                          />
                        </div>
                      </div>
                      <div class="row margin-t-s">
                        <div class="col-4 margin-t-s">
                          % of tax benefit claimed by joint Holder
                        </div>
                        <div class="col-4">
                          <txt
                            type="number"
                            :name="'tax_benefit' + index"
                            v-model="letout.tax_benefit"
                          />
                        </div>
                      </div>
                      <div class="row margin-t-s">
                        <btn
                          class="custom-btn-block"
                          text="Approve"
                          type="primary"
                          @click="letoutApprove(letout)"
                        />
                        <btn
                          class="btn-sm custom-btn-block mx-2"
                          text="Partially Approve"
                          type="primary"
                          @click="letoutPartiallyApprove('Letout')"
                        ></btn>
                        <btn
                          class="btn-sm custom-btn-block"
                          text="Reject"
                          type="primary"
                          @click="letoutReject('Letout')"
                        ></btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </tl-accordion>
    <!-- <tl-accordion :disabled="!isOtherIncomeAllowed"> this will enable when we check -->
    <tl-accordion>
      <template v-slot:accordionHeader>
        <div class="row">
          <div class="col-6">Other Income</div>
          <div class="col-6 align-right"></div>
        </div>
      </template>
      <template v-slot:accordionBody>
        <data-table
          :columns="otherIncTableColumns"
          :tableData="otherIncomeList"
          :withForm="false"
          :showinrow="false"
          :showmodal="false"
          :showedit="false"
          :showdelete="false"
          :showhistory="false"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'slno'">
                {{ slotprops.value.index + 1 }}
              </p>
              <p v-if="slotprops.value.column.key == 'particulars'">
                {{
                  slotprops.value.record.InvestmentComponentType
                    ? slotprops.value.record.InvestmentComponentType.name
                    : slotprops.value.record.name
                }}
              </p>
              <!-- <p
                        v-if="slotprops.value.column.key == 'limits'"
                      >₹ {{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount : (Object.keys(slotprops.value.record.rule).length ?slotprops.value.record.rule.maximum_limit:null)}}</p> -->
              <p v-if="slotprops.value.column.key == 'planned'">
                ₹ {{ otherIncomeList[slotprops.value.index].planned }}
                <!-- <txt
                      type="number"
                      :disable="true"
                      :name="'oivalue'+slotprops.value.index"
                      v-model="otherIncomeList[slotprops.value.index].planned"
                    /> -->
              </p>
              <p v-if="slotprops.value.column.key == 'actual'">
                ₹ {{ otherIncomeList[slotprops.value.index].actual }}
                <!-- <txt
                      type="number"
                      :name="'oivalue'+slotprops.value.index"
                      v-model="otherIncomeList[slotprops.value.index].actual"
                    /> -->
              </p>
              <p v-if="slotprops.value.column.key == 'proof'">
                <a
                  href="javascript:void(0)"
                  v-if="slotprops.value.record[slotprops.value.column.key]"
                  @click="
                    openDocModal(
                      otherIncomeList[slotprops.value.index].proof,
                      slotprops.value.index,
                      'other-income'
                    )
                  "
                  ><img
                    class="atch-img"
                    :src="require('@/assets/ic-attachment.png')"
                  />
                  {{
                    slotprops.value.record[slotprops.value.column.key].length
                  }}
                  attachment</a
                >
              </p>
              <div
                class="action-section"
                v-if="slotprops.value.column.key == 'action'"
              >
                <img
                  src="@/assets/group-2.png"
                  class="pointer-cursor"
                  @click="
                    dropdown4(slotprops.value.record,slotprops.value.index)
                  "
                  alt="actionIcon"
                />
                <ul
                  class="action-menu"
                  v-show="otherIncomeList[slotprops.value.index].showDropDown"
                >
                  <li>
                    <span class @click="otherApprove(slotprops.value.record,slotprops.value.index)"
                      >Approve</span
                    >
                  </li>
                  <li>
                    <span
                      class
                      @click="otherPartiallyApprove(slotprops.value.record, slotprops.value.index)"
                      >Partially Approve</span
                    >
                  </li>
                  <li>
                    <span class @click="otherReject(slotprops.value.record,slotprops.value.index)"
                      >Reject</span
                    >
                  </li>
                </ul>
              </div>
              <!-- <p v-if="slotprops.value.column.key == 'action'">
                    <label class="fileLabel" :for="'ofile'+slotprops.value.index">
                      <img src="@/assets/group-5.svg" class="plus-icon" />
                      <input
                        type="file"
                        :id="'ofile'+slotprops.value.index"
                        @change="uploadFile($event.target.files[0], slotprops.value.index, 'otherIncome')"
                      />
                    </label>
                  </p> -->
            </div>
          </template>
        </data-table>
      </template>
    </tl-accordion>

    <tl-accordion>
      <template v-slot:accordionHeader>
        <div class="row">
          <div class="col-6">Previous Employment Details</div>
          <div class="col-6 align-right"></div>
        </div>
      </template>
      <template v-slot:accordionBody>
        <ul class="table-header header-table">
          <li class="table-header-item">Particulars</li>
          <li class="table-header-item">Amount</li>
          <li class="table-header-item">Proofs</li>
          <li class="table-header-item"></li>
        </ul>
        <div class="row-div">
          <ul class="table-row">
            <li class="table-row-item">Salary Income After Section 10</li>
            <li class="table-row-item">
              <txt
                type="number"
                name="salary_income"
                v-model="previousEmploymentDetails.salary_income.amount"
              />
            </li>
            <li class="table-row-item">
              <a
                href="javascript:void(0)"
                @click="
                  openDocModal(
                    previousEmploymentDetails.salary_income.location,
                    'salary-income'
                  )
                "
                >{{
                  previousEmploymentDetails.salary_income.location.length
                }}
                attachments</a
              >
            </li>
            <div class="row my-3">
              <btn
                class="btn-sm custom-btn-block"
                text="Approve"
                type="primary"
                @click="peApprove('salary_income')"
              />
              <btn
                class="btn-sm custom-btn-block mx-2"
                text="Partially Approve"
                type="primary"
                @click="pePartiallyApprove('salary_income')"
              ></btn>
              <btn
                class="btn-sm custom-btn-block"
                text="Reject"
                type="primary"
                @click="peReject('salary_income')"
              ></btn>
            </div>

            <!-- <li class="table-row-item text-center">
              <label class="fileLabel" for="salary_income">
                <img src="@/assets/group-5.svg" class="plus-icon" />
                <input
                  type="file"
                  id="salary_income"
                  @change="
                    uploadPEProof($event.target.files[0], 'salary_income')
                  "
                />
              </label>
            </li> -->
          </ul>
          <ul class="table-row">
            <li class="table-row-item">PT Amount</li>
            <li class="table-row-item">
              <txt
                type="number"
                name="pt"
                v-model="previousEmploymentDetails.pt.amount"
              />
            </li>
            <li class="table-row-item">
              <a
                href="javascript:void(0)"
                @click="
                  openDocModal(previousEmploymentDetails.pt.location, 'pt')
                "
                >{{
                  previousEmploymentDetails.pt.location.length
                }}
                attachments</a
              >
            </li>
            <div class="row my-3">
              <btn
                class="btn-sm custom-btn-block"
                text="Approve"
                type="primary"
                @click="peApprove('PT')"
              />
              <btn
                class="btn-sm custom-btn-block mx-2"
                text="Partially Approve"
                type="primary"
                @click="pePartiallyApprove('PT')"
              ></btn>
              <btn
                class="btn-sm custom-btn-block"
                text="Reject"
                type="primary"
                @click="peReject('PT')"
              ></btn>
            </div>
            <!-- <li class="table-row-item text-center">
              <label class="fileLabel" for="pt">
                <img src="@/assets/group-5.svg" class="plus-icon" />
                <input
                  type="file"
                  id="pt"
                  @change="uploadPEProof($event.target.files[0], 'pt')"
                />
              </label>
            </li> -->
          </ul>
          <ul class="table-row">
            <li class="table-row-item">VPF</li>
            <li class="table-row-item">
              <txt
                type="number"
                name="vpf"
                v-model="previousEmploymentDetails.vpf.amount"
              />
            </li>
            <li class="table-row-item">
              <a
                href="javascript:void(0)"
                @click="
                  openDocModal(previousEmploymentDetails.vpf.location, 'vpf')
                "
                >{{
                  previousEmploymentDetails.vpf.location.length
                }}
                attachments</a
              >
            </li>
            <div class="row my-3">
              <btn
                class="btn-sm custom-btn-block"
                text="Approve"
                type="primary"
                @click="peApprove('VPF')"
              />
              <btn
                class="btn-sm custom-btn-block mx-2"
                text="Partially Approve"
                type="primary"
                @click="pePartiallyApprove('VPF')"
              ></btn>
              <btn
                class="btn-sm custom-btn-block"
                text="Reject"
                type="primary"
                @click="peReject('VPF')"
              ></btn>
            </div>
            <!-- <li class="table-row-item text-center">
              <label class="fileLabel" for="vpf">
                <img src="@/assets/group-5.svg" class="plus-icon" />
                <input
                  type="file"
                  id="vpf"
                  @change="uploadPEProof($event.target.files[0], 'vpf')"
                />
              </label>
            </li> -->
          </ul>
          <ul class="table-row">
            <li class="table-row-item">PF</li>
            <li class="table-row-item">
              <txt
                type="number"
                name="pf"
                v-model="previousEmploymentDetails.pf.amount"
              />
            </li>
            <li class="table-row-item">
              <a
                href="javascript:void(0)"
                @click="
                  openDocModal(previousEmploymentDetails.pf.location, 'pf')
                "
                >{{
                  previousEmploymentDetails.pf.location.length
                }}
                attachments</a
              >
            </li>
            <div class="row my-3">
              <btn
                class="btn-sm custom-btn-block"
                text="Approve"
                type="primary"
                @click="peApprove('PF')"
              />
              <btn
                class="btn-sm custom-btn-block mx-2"
                text="Partially Approve"
                type="primary"
                @click="pePartiallyApprove('PF')"
              ></btn>
              <btn
                class="btn-sm custom-btn-block"
                text="Reject"
                type="primary"
                @click="peReject('PF')"
              ></btn>
            </div>
            <!-- <li class="table-row-item text-center">
              <label class="fileLabel" for="pf">
                <img src="@/assets/group-5.svg" class="plus-icon" />
                <input
                  type="file"
                  id="pf"
                  @change="uploadPEProof($event.target.files[0], 'pf')"
                />
              </label>
            </li> -->
          </ul>
          <ul class="table-row">
            <li class="table-row-item">NPS</li>
            <li class="table-row-item">
              <txt
                type="number"
                name="nps"
                v-model="previousEmploymentDetails.nps.amount"
              />
            </li>
            <li class="table-row-item">
              <a
                href="javascript:void(0)"
                @click="
                  openDocModal(previousEmploymentDetails.nps.location, 'nps')
                "
                >{{
                  previousEmploymentDetails.nps.location.length
                }}
                attachments</a
              >
            </li>
            <div class="row my-3">
              <btn
                class="btn-sm custom-btn-block"
                text="Approve"
                type="primary"
                @click="peApprove('NPS')"
              />
              <btn
                class="btn-sm custom-btn-block mx-2"
                text="Partially Approve"
                type="primary"
                @click="pePartiallyApprove('NPS')"
              ></btn>
              <btn
                class="btn-sm custom-btn-block"
                text="Reject"
                type="primary"
                @click="peReject('NPS')"
              ></btn>
            </div>
            <!-- <li class="table-row-item text-center">
              <label class="fileLabel" for="nps">
                <img src="@/assets/group-5.svg" class="plus-icon" />
                <input
                  type="file"
                  id="nps"
                  @change="uploadPEProof($event.target.files[0], 'nps')"
                />
              </label>
            </li> -->
          </ul>
          <ul class="table-row" >
            <li class="table-row-item">Income Tax Deduction</li>
            <li class="table-row-item">
              <txt
                type="number"
                name="tds"
                v-model="previousEmploymentDetails.tds.amount"
              />
            </li>
            <li class="table-row-item">
              <a
                href="javascript:void(0)"
                @click="
                  openDocModal(previousEmploymentDetails.tds.location, 'tds')
                "
                >{{
                  previousEmploymentDetails.tds.location.length
                }}
                attachments</a
              >
            </li>
            <div class="row my-3">
              <btn
                class="btn-sm custom-btn-block"
                text="Approve"
                type="primary"
                @click="peApprove('TDS')"
              />
              <btn
                class="btn-sm custom-btn-block mx-2"
                text="Partially Approve"
                type="primary"
                @click="pePartiallyApprove('TDS')"
              ></btn>
              <btn
                class="btn-sm custom-btn-block"
                text="Reject"
                type="primary"
                @click="peReject('TDS')"
              ></btn>
            </div>
            <!-- <li class="table-row-item text-center">
              <label class="fileLabel" for="tds">
                <img src="@/assets/group-5.svg" class="plus-icon" />
                <input
                  type="file"
                  id="tds"
                  @change="uploadPEProof($event.target.files[0], 'tds')"
                />
              </label>
            </li> -->
          </ul>
        </div>
      </template>
    </tl-accordion>

    <div class="modal custom-modal" v-if="showDocModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <div class="row">
            <div class="col-12">
              <h3>Documents</h3>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="carousel">
            <img :src="docUrl" alt class="docImage" />
            <div class="text-center">
              <a
                href="javascript:void(0)"
                @click="prev()"
                class="arrow arrow-prev"
                >&lt;</a
              >
              <a
                href="javascript:void(0)"
                @click="next()"
                class="arrow arrow-next"
                >&gt;</a
              >
            </div>
            <br />
            <div class="text-center my-3">
              <span class="delete-download add-new-document">
                <a
                  href="javascript:void(0)"
                  v-if="showDeleteDoc"
                  class="close-btnn"
                  style="text-decoration: none"
                  @click="deleteDoc(index)"
                  >Delete</a
                >
              </span>
              <sapn class="delete-download add-new-document">
                <a
                  :href="docUrl"
                  download="file"
                  style="text-decoration: none"
                  class="close-btnn"
                >
                  <img src="@/assets/download.svg" class="img" />&nbsp;
                  <span class="text">Download</span>
                </a>
              </sapn>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <!-- <div class="col-6 text-left">
              <a
                href="javascript:void(0)"
                v-if="showDeleteDoc"
                class="close-btn"
                @click="deleteDoc(index)"
              >Delete</a>
            </div> -->
            <div class="col-12">
              <!-- <a :href="docUrl" download="file" class="close-btn">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Download</span>
              </a> -->
              <btn
                text="Close"
                type="secondary"
                class="btn-lg"
                @click="okbtn"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup 6 -->
    <pop-up-window
      v-if="showPopupuploadAttachment"
      @back="showPopupuploadAttachment = !showPopupuploadAttachment"
      header="Document"
    >
      <template v-slot:content>
        <upload-attachment
          @selectedAttachment="openFullAttachment"
          @back="!openFullAttachment && !showPopupuploadAttachment"
          :docsList="docsList"
          :title="title"
        >
        </upload-attachment>
      </template>
    </pop-up-window>
    <!-- End -->

    <!-- Approve popup message -->
    <pop-up-message
      v-if="showApproveConfirmation"
      :message="'investment proofs approved succesfully.'"
      popupHeaderMessage="Success"
      :popupType="'Success'"
      @back="backFromPopup"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup" type="button" @click="approveInvestment">
            Okay
          </button>
        </div>
      </template>
    </pop-up-message>
    <!-- End -->

  
      <!-- Approve popup message -->
    <pop-up-message
      v-if="showApproveConfirmation2"
      :message="'investment proofs approved succesfully.'"
      popupHeaderMessage="Success"
      :popupType="'Success'"
      @back="backFromPopup"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup" type="button" @click="approveInvestment2">
            Okay
          </button>
        </div>
      </template>
    </pop-up-message>
    <!-- End --> 
     <!-- Approve popup message -->
    <pop-up-message
      v-if="showApproveConfirmation3"
      :message="'investment proofs approved succesfully.'"
      popupHeaderMessage="Success"
      :popupType="'Success'"
      @back="backFromPopup"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup" type="button" @click="approveInvestment3">
            Okay
          </button>
        </div>
      </template>
    </pop-up-message>
    <!-- End --> 
    <!-- Another Popup Message show Partially Approve -->
    <div class="modal" v-if="showConfirmationMsg">
      <div class="modal-content" ref="modalBox">
        <div class="top-bar">
          <span class="heading_new">Partially Approve Investment Proof</span>
        </div>
        <div class="message-text">
          Particular: <strong>{{ ParticularName }}</strong>
        </div>
        <div class="message-text">
          Actual Investment: <strong>₹ {{ theAmount }}</strong>
        </div>
        <br />
        <txt
          label="Approved Amount"
          type="number"
          name="amount"
          v-model="partialAmount"
        />
        <br />
        <txt
          class="remarks"
          label="Remark"
          name="remarks"
          type="textarea"
          rows="4"
          v-model="comment"
        />
        Max 256 characters
        <br />
        <div class="popup-btns">
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn
              text="Save"
              type="primary"
              @click="saveInvestmentProof"
            />
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- End here -->

    <!-- Another Popup Message show Partially Approve -->
    <div class="modal" v-if="showConfirmationMsg2">
      <div class="modal-content" ref="modalBox">
        <div class="top-bar">
          <span class="heading_new">Partially Approve Investment Proof</span>
        </div>
        <div class="message-text">
          Particular: <strong>{{ ParticularName }}</strong>
        </div>
        <div class="message-text">
          Actual Investment: <strong>₹ {{ theAmount }}</strong>
        </div>
        <br />
        <txt
          label="Approved Amount"
          type="number"
          name="amount"
          v-model="partialAmount"
        />
        <br />
        <txt
          class="remarks"
          label="Remark"
          name="remarks"
          type="textarea"
          rows="4"
          v-model="comment"
        />
        Max 256 characters
        <br />
        <div class="popup-btns">
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn
              text="Save"
              type="primary"
              @click="saveInvestmentProof2"
            />
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- End here -->
     <!-- Another Popup Message show Partially Approve -->
    <div class="modal" v-if="showConfirmationMsg3">
      <div class="modal-content" ref="modalBox">
        <div class="top-bar">
          <span class="heading_new">Partially Approve Investment Proof</span>
        </div>
        <div class="message-text">
          Particular: <strong>{{ ParticularName }}</strong>
        </div>
        <div class="message-text">
          Actual Investment: <strong>₹ {{ theAmount }}</strong>
        </div>
        <br />
        <txt
          label="Approved Amount"
          type="number"
          name="amount"
          v-model="partialAmount"
        />
        <br />
        <txt
          class="remarks"
          label="Remark"
          name="remarks"
          type="textarea"
          rows="4"
          v-model="comment"
        />
        Max 256 characters
        <br />
        <div class="popup-btns">
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn
              text="Save"
              type="primary"
              @click="saveInvestmentProof3"
            />
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- End here -->

    <!-- Another Popup Message show Reject -->
    <div class="modal" v-if="showRejectMsg">
      <div class="modal-content" ref="modalBox">
        <div class="top-bar">
          <span class="heading_new">Reject Investment Proof</span>
        </div>
        <div class="message-text">
          Particular: <strong>{{ ParticularName }}</strong>
        </div>
        <div class="message-text">
          Actual Investment: <strong>₹ {{ theAmount }}</strong>
        </div>
        <br />
        <txt
          class="remarks"
          label="Remark"
          name="remarks"
          type="textarea"
          rows="4"
          v-model="comment"
        />
        Max 256 characters
        <br />
        <div class="popup-btns">
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn text="Save" type="primary" @click="saveRejectProof" />
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- End here -->

     <!-- Another Popup Message show Reject -->
    <div class="modal" v-if="showRejectMsg2">
      <div class="modal-content" ref="modalBox">
        <div class="top-bar">
          <span class="heading_new">Reject Investment Proof</span>
        </div>
        <div class="message-text">
          Particular: <strong>{{ ParticularName }}</strong>
        </div>
        <div class="message-text">
          Actual Investment: <strong>₹ {{ theAmount }}</strong>
        </div>
        <br />
        <txt
          class="remarks"
          label="Remark"
          name="remarks"
          type="textarea"
          rows="4"
          v-model="comment"
        />
        Max 256 characters
        <br />
        <div class="popup-btns">
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn text="Save" type="primary" @click="saveRejectProof2" />
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- End here -->
      <!-- Another Popup Message show Reject -->
    <div class="modal" v-if="showRejectMsg3">
      <div class="modal-content" ref="modalBox">
        <div class="top-bar">
          <span class="heading_new">Reject Investment Proof</span>
        </div>
        <div class="message-text">
          Particular: <strong>{{ ParticularName }}</strong>
        </div>
        <div class="message-text">
          Actual Investment: <strong>₹ {{ theAmount }}</strong>
        </div>
        <br />
        <txt
          class="remarks"
          label="Remark"
          name="remarks"
          type="textarea"
          rows="4"
          v-model="comment"
        />
        Max 256 characters
        <br />
        <div class="popup-btns">
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn text="Save" type="primary" @click="saveRejectProof3" />
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- End here -->

    <!-- Modal Popup Section 10  -->
    <div class="modal" v-if="showSection10Msg">
      <div class="modal-content-section" ref="modalBox">
        <div class="">
          <h3>Section 10: Name</h3>
          <!-- <span class="img-close" >
              <img class="img-size-close" src="@/assets/cross.svg" />
          </span> -->
          <br />
          <p><strong>Bill Number-</strong></p>
          <p><strong>Bill Date-</strong></p>
          <p><strong>Service Provider-</strong></p>
          <p><strong>Account Number-</strong></p>
          <p><strong>Bill Amount-</strong></p>
          <br />
          <div class="row">
            <div class="col-12 text-center">
              <btn
                text="Close"
                type="secondary"
                class="btn-sm"
                @click="closeIcon"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End here -->

    <!-- Modal Popup Section 17  -->
    <div class="modal" v-if="showSection17Msg">
      <div class="modal-content-section" ref="modalBox">
        <div class="">
          <h3>Section 17: Name</h3>
          <!-- <span class="img-close" >
              <img class="img-size-close" src="@/assets/cross.svg" />
          </span> -->
          <br />
          <p><strong>Bill/Recipe Number-</strong></p>
          <p><strong>Bill/Recipe Date-</strong></p>
          <p><strong>For Month-</strong></p>
          <p><strong>Service Provider-</strong></p>
          <p><strong>Account Number-</strong></p>
          <p><strong>Bill/Recipe Amount-</strong></p>
          <br />
          <div class="row">
            <div class="col-12 text-center">
              <btn
                text="Close"
                type="secondary"
                class="btn-sm"
                @click="closeIcon"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End here -->

    <!-- Modal Popup 80C Chapter VI A  -->
    <div class="modal" v-if="showChapterVIMsg">
      <div class="modal-content-section" ref="modalBox">
        <div class="">
          <h3>80C (Chapter VIA): Name</h3>
          <!-- <span class="img-close" >
              <img class="img-size-close" src="@/assets/cross.svg" />
          </span> -->
          <br />
          <p><strong>Policy Number-</strong></p>
          <p><strong>Policy Holder Name-</strong></p>
          <p><strong>Sum Assured-</strong></p>
          <p><strong>Policy Date-</strong></p>
          <p><strong>Date of Payment-</strong></p>
          <p><strong>Premium Amount-</strong></p>
          <br />
          <div class="row">
            <div class="col-12 text-center">
              <btn
                text="Close"
                type="secondary"
                class="btn-sm"
                @click="closeIcon"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End here -->
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import dependentsPopup from "./dependentsPopup.vue";
import addDependentsPopup from "./addDependentsPopup.vue";
import uploadAttachment from "./uploadAttachment.vue";
import fullAttachmentShow from "./fullAttachmentShow.vue";
import {
  get_axios_file_instance,
  api_variables,
  errorHandler,
} from "@/apis/variables.js";

var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);
import { eventBus } from "@/main";
export default {
  name: "pending",
  components: {
    dependentsPopup,
    addDependentsPopup,
    uploadAttachment,
    fullAttachmentShow,
  },
  props: {
    dataAll: {
      type: Object,
    },
  },
  data() {
    return {
      showDocModal: false,
      employeeObj: null,
      showConfirmationMsg: false,
      showConfirmationMsg2: false,
      showConfirmationMsg3: false,
      showRejectMsg: false,
      showRejectMsg2: false,
      showRejectMsg3: false,
      ParticularName: null,
      theAmount: null,
      info:null,
      personal: {
        first_name: null,
        last_name: null,
        code: null,
      },
      approvalData: null,
      rejectData: null,
      partialApproveData: null,
      title: null,
      partialAmount: null,
      comment: null,
      tempRecord: null,
      // salary: {
      //   ctc: null,
      //   salary_structure_id: null,
      //   exempt_for_it_deduction_first_month: false,
      //   master_salary_structure: [],
      // },
      it_plan_id: "",
      employeeId: "",
      instance: {
        le_id: "",
        employee_id: "",
        financial_year: "",
        it_plan_id: "",
      },
      data2: {
        exemption10: {
          HRA: [
            {
              address: "",
              pincode: "",
              State: "",
              cityType: "metro",
              rentList: [
                {
                  rentFrom: "",
                  rentTo: "",
                  amount: 0,
                  agreementDoc: "",
                  fileName: "",
                },
              ],
              ownerDetails: {
                name: "",
                pan_number: "",
                pincode: "",
                address: "",
                state: "",
                pancardUrl: "",
                fileName: "",
                isCoOwner: false,
                cownerDetails: {
                  name: "",
                  pan_number: "",
                  pincode: "",
                  address: "",
                  state: "",
                  pancardUrl: "",
                  fileName: "",
                },
              },
            },
          ],
          others: [],
        },
        exemption17: [],
        deductionsUnderChapterVIA: [],
        section24: [],
        previousEmploymentDetails: {},
        otherIncome: [],
        deductionsUnderSection16: {
          Section16: null,
        },
        le_id: "",
        employee_id: "",
        financial_year: "",
        plan_id: "",
        regime_type: "",
      },
      section10Update: [],

      salaryPerk: [],
      tds_breakup_and_taxable_income: [],
      itSheet: [],
      first_name: "",
      last_name: "",
      ctc: "",
      code: "",
      totalIncomeTax: "",
      annualIncome: 0,
      incomeTax: 0,
      totalIncome: 0,
      totalTax: 0,
      showPopupdependentsPopup: false,
      showPopupaddDependentsPopup: false,
      showPopupaddNewInvestmentPopup: false,
      showPopupviewDownloadFormsPopup: false,
      showPopupfullviewDownloadFormsPopup: false,
      showPopupuploadAttachment: false,
      showPopupfullAttachmentShow: false,
      showPopupsection10Popup: false,
      showSection10Msg: false,
      showSection17Msg: false,
      showChapterVIMsg: false,
      salaryTableColumns: [],
      deductionsList: [],
      perksList: [],
      salaryList: [],
      data80CList: [],
      chapterOtherDataList: [],
      showPopupsection17Popup: false,
      showPopupChapterVIAPopup: false,
      section10record: [],
      section17record: [],
      section6arecord: [],
      tableColumnsSection10: [
        {
          label: "SL No.",
          key: "slno",
        },
        {
          label: "Particulars",
          key: "particulars",
        },
        {
          label: "Yearly Limit",
          key: "limits",
        },
        // {
        // label: "Planned Investment(₹)",
        // key: "planned"
        // },
        {
          label: "Actual Investment(₹)",
          key: "actual",
        },
        {
          label: "Proofs",
          key: "file_location",
        },
        {
          label: "Actions",
          key: "action",
        },
      ],
      section10List: [],
      tableColumnsSection17: [
        {
          label: "SL No.",
          key: "slno",
        },
        {
          label: "Particulars",
          key: "particulars",
        },
        {
          label: "Yearly Limit",
          key: "limits",
        },
        // {
        // label: "Planned Investment(₹)",
        // key: "planned"
        // },
        {
          label: "Actual Investment(₹)",
          key: "actual",
        },
        {
          label: "Proofs",
          key: "file_location",
        },
        {
          label: "Actions",
          key: "action",
        },
      ],
      section17List: [],
      tableColumns80C: [
        {
          label: "SL No.",
          key: "slno",
        },
        {
          label: "Particulars",
          key: "particulars",
        },
        {
          label: "Yearly Limit",
          key: "limits",
        },
        // {
        // label: "Planned Investment(₹)",
        // key: "planned"
        // },
        {
          label: "Actual Investment(₹)",
          key: "actual",
        },
        {
          label: "Proofs",
          key: "file_location",
        },
        {
          label: "Actions",
          key: "action",
        },
      ],
      tableColumnsotherIncome: [
        {
          label: "Particulars",
          key: "particulars",
        },
        {
          label: "Yearly Limit",
          key: "yearly_limit",
        },
        {
          label: "Planned Investment(₹)",
          key: "planned_investment",
        },
        {
          label: "Actual Investment(₹)",
          key: "actual_investment",
        },
        {
          label: "Proofs",
          key: "proofs_attachment",
        },
      ],

      iTaxProofPlan: true,
      iTaxProofFormPlan: false,
      showApproveConfirmation: false,
      showApproveConfirmation2: false,
      showApproveConfirmation3: false,
      section10sum: 0,
      section17sum: 0,
      chapter6asum: 0,
      section24sum: 0,
      otherincomesum: 0,
      totalPlannedInvestment: 0,

      section24: {
        let_out_property: [
          {
            letOut: [],
            total_planned: 0,
            total_actual: 0,
            approved: 0,
            audit_remarks:null,
            status: null,
            proof: [],
            joint_holder_name: "",
            relationship: "",
            tax_benefit: 0,
          },
        ],
        self_occupied: {
          selfOccupied: [],
          total_planned: 0,
          total_actual: 0,
          approved: 0,
          status: null,
          audit_remarks:null,
          proof: [],
          joint_holder_name: "",
          relationship: "",
          tax_benefit: 0,
        },
      },
      previousEmploymentDetails: {
        salary_income: { amount: 0, location: [], approved: 0, status: null, audit_remarks:null, },
        pt: { amount: 0, location: [], approved: 0, status: null, audit_remarks:null, },
        vpf: { amount: 0, location: [], approved: 0, status: null, audit_remarks:null, },
        pf: { amount: 0, location: [], approved: 0, status: null, audit_remarks:null, },
        nps: { amount: 0, location: [], approved: 0, status: null, audit_remarks:null, },
        tds: { amount: 0, location: [], approved: 0, status: null, audit_remarks:null, },
      },
      otherIncomeList: [
        {
          name: "Interest From saving Accounts",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          audit_remarks:null,
          file_location: "",
          status: "",
          type: "",
        },
        {
          name: "Interest From Fixed Deposits",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          audit_remarks:null,
          file_location: "",
          status: "",
          type: "",
        },
        {
          name: "Any other Income",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          audit_remarks:null,
          file_location: "",
          status: "",
          type: "",
        },
      ],
      otherIncTableColumns: [
        {
          label: "SL No.",
          key: "slno",
        },
        {
          label: "Particulars",
          key: "particulars",
        },
        // {
        //   label: "Yearly Limit",
        //   key: "limits"
        // },
        {
          label: "Planned",
          key: "planned",
        },
        {
          label: "Actual",
          key: "actual",
        },
        {
          label: "Proofs",
          key: "proof",
        },
        {
          label: "Actions",
          key: "action",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData",
      record: "dashboard/payroll/incometax/record",
    
    }),
    ...mapState({
      globalData: (state) => state.globalapi.globalData.data,
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
  },

  mounted() {
    // this.fetechAllNewInvestment();
    //this.fetchItData();
    this.fetchItData();
    this.dataAll=this.record;
    
  },
  activated() {
    
    
    // this.fetechAllNewInvestment();
  },
  created() {

  },
  methods: {
    async fetchItData() {
      let res = this.dataAll;

      if (res) {
        this.salaryList = [];
        this.deductionsList = [];
        this.perksList = [];
        let obj = res;
        
        this.totalTax = obj.itSheet[0].totalTax;
        this.totalIncome = obj.itSheet[0].taxableIncome;
        this.incomeTax = obj.itSheet[0].incomeTax;
        this.annualIncome = obj.itSheet[0].totalEarning;
        this.data80CList = [];
        this.section10List = [];
        this.section17List = [];
        this.data2.exemption10 = obj.Exemption10;
        this.data2.exemption17 = obj.Exemption17;
        this.data2.deductionsUnderChapterVIA = obj.deductionsUnderChapterVIA;
        this.data2.section24 = obj.section24;
        this.data2.previousEmploymentDetails = obj.previousEmploymentDetails;
        this.data2.otherIncome = obj.otherIncome;
        this.data2.le_id = obj.le_id;
        this.data2.employee_id = this.instance.employee_id;
        this.data2.financial_year = this.instance.financial_year;
        this.data2.plan_id = this.instance.it_plan_id;
        /* Section 10 data table push*/

        obj.Exemption10.others.forEach((element) => {
          this.regime_type = element.regime_type;
          this.section10List.push({
            planned: element.planned ? element.planned : 0,
            actual: element.actual ? element.actual : 0,
            ...element,
          });
        });

        /* Section 17 data table push*/
        obj.Exemption17.Section17.forEach((element) => {
          this.section17List.push({
            planned: element.planned ? element.planned : 0,
            actual: element.actual ? element.actual : 0,
            ...element,
          });
        });
        /* ChapterVIA data table push*/
        obj.deductionsUnderChapterVIA.forEach((element) => {
          this.data80CList.push({
            planned: element.planned ? element.planned : 0,
            actual: element.actual ? element.actual : 0,
            ...element,
          });
        });
        /* let out property data table push*/
        if (Object.keys(obj.section24).length) {
          if (obj.section24.let_out_property.length) {
            this.section24.let_out_property = obj.section24.let_out_property;
          }
          this.section24.self_occupied = obj.section24.self_occupied;
          this.section24sum = this.section24.let_out_property.total_planned;
        }
        /* Other Income data table push*/
        if (obj.otherIncome.length) {
          this.otherIncomeList = obj.otherIncome;
        }

        /* previous employment Details data table push*/
        if (Object.keys(obj.previousEmploymentDetails).length) {
          this.previousEmploymentDetails = obj.previousEmploymentDetails;
        }

        this.section10List.forEach((element) => {
          this.section10sum += element.planned;
        });
        this.section17List.forEach((element) => {
          this.section17sum += element.planned;
        });
        this.data80CList.forEach((element) => {
          this.chapter6asum += element.planned;
        });
        this.otherIncomeList.forEach((element) => {
          this.otherincomesum += element.planned;
        });
        this.totalPlannedInvestment = 0;
        this.totalPlannedInvestment =
          this.section10sum +
          this.section17sum +
          this.chapter6asum +
          this.otherincomesum;

        this.data2.exemption10.HRA = obj.Exemption10.HRA;
      }
    },

    backFromPopup() {
      this.showApproveConfirmation = false;
      this.showApproveConfirmation2 = false;
      this.showApproveConfirmation3 = false;
    },

    openFullAttachment() {
      (this.showPopupuploadAttachment = false),
        (this.showPopupfullAttachmentShow = true);
    },

    openDocModal(docList, index, section) {
      try {
        if (docList.length) {
          this.docsList = docList;
          this.docIndex = 0;
          this.index = 0;
          this.docUrl = this.docsList[0];
          this.currentDocIndex = index;
          this.showPopupuploadAttachment = true;
          this.currentFileSection = section;
        }
        if (section == "Section10") {
          this.showDeleteDoc = false;
        } else {
          this.showDeleteDoc = true;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    okbtn() {
      this.showModal = false;
      this.showDocModal = false;
    },

    dropdown(slots) {
      try {
        let idx = this.section10List.findIndex((obj) => {
          return obj.id == slots.id;
        });
        this.section10List.forEach((data, index) => {
          if (index !== idx) {
            data.showDropDown = false;
          }
        });
        if (idx > -1) {
          this.section10List[idx].showDropDown = this.section10List[idx]
            .showDropDown
            ? false
            : true;
          this.section10List = [...this.section10List];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    dropdown2(slots) {
      try {
        let idx = this.section17List.findIndex((obj) => {
          return obj.id == slots.id;
        });
        this.section17List.forEach((data, index) => {
          if (index !== idx) {
            data.showDropDown = false;
          }
        });
        if (idx > -1) {
          this.section17List[idx].showDropDown = this.section17List[idx]
            .showDropDown
            ? false
            : true;
          this.section17List = [...this.section17List];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    dropdown3(slots) {
      try {
        let idx = this.data80CList.findIndex((obj) => {
          return obj.id == slots.id;
        });
        this.data80CList.forEach((data, index) => {
          if (index !== idx) {
            data.showDropDown = false;
          }
        });
        if (idx > -1) {
          this.data80CList[idx].showDropDown = this.data80CList[idx]
            .showDropDown
            ? false
            : true;
          this.data80CList = [...this.data80CList];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    dropdown4(slots, colIndex) {
      try {
        this.otherIncomeList.forEach((data, index) => {
          if (index !== colIndex) {
            data.showDropDown = false;
          } else {
            this.otherIncomeList[colIndex].showDropDown = this.otherIncomeList[colIndex]
              .showDropDown
              ? false
              : true;
          }
        });
        this.otherIncomeList = [...this.otherIncomeList];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    // Dropdown Menu Funcion
    approve(record) {
      //this.otherIncomeList[colIndex].showDropDown = false;
      //this.otherIncomeList = [...this.otherIncomeList];
      this.approvalData = record;
      

      this.showApproveConfirmation = true;
    },
    otherApprove(record) {
      //this.otherIncomeList[colIndex].showDropDown = false;
      //this.otherIncomeList = [...this.otherIncomeList];
      this.approvalData = record;
      this.approvalData.status='approved';
      this.approvalData.approved=this.approvalData.actual;
      

      this.showApproveConfirmation2 = true;
    },
    otherPartiallyApprove(record) {
      //this.otherIncomeList[colIndex].showDropDown = false;
      //this.otherIncomeList = [...this.otherIncomeList];
     
      this.tempRecord = record;
      this.ParticularName = this.tempRecord.name;
      this.theAmount = this.tempRecord.actual;
      this.showConfirmationMsg2 = true;
    },

    otherReject(record) {
     
     this.rejectData = record;
      this.ParticularName = this.rejectData.name;
      this.theAmount = this.rejectData.actual;
      this.showRejectMsg2 = true;
    },

    partiallyApprove(record) {
      //this.otherIncomeList[colIndex].showDropDown = false;
      //this.otherIncomeList = [...this.otherIncomeList];
      this.tempRecord = record;
      this.ParticularName = this.tempRecord.InvestmentComponentType.name;
      this.theAmount = this.tempRecord.actual;
      this.showConfirmationMsg = true;
    },

    reject(record) {
      //this.otherIncomeList[colIndex].showDropDown = false;
      //this.otherIncomeList = [...this.otherIncomeList];
      this.rejectData = record;
      this.ParticularName = this.rejectData.InvestmentComponentType.name;
      this.theAmount = this.rejectData.actual;
      this.showRejectMsg = true;
    },

    /**  here we can pass data child to child using emit
     * eventBus.$emit() method to pass data to any child component
     * And here to send data to another child component use below method
     * export in class
     * created() {
        eventBus.$on('approveInvestment', this.approveInvestmentFunction);
      }
      Above method is crete in child approveInvestmentFunction 
      and pass arguments(arg1, arg2,...)
    */
    // Popup  Save function
    approveInvestment() {
      eventBus.$emit("approveInvestment", this.approvalData);
      this.showApproveConfirmation = false;
    },
    approveInvestment2() {
      eventBus.$emit("approveInvestment2", this.approvalData);
      this.showApproveConfirmation2 = false;
    },
    approveInvestment3() {
      eventBus.$emit("approveInvestment3", this.tempRecord,this.info);
      this.showApproveConfirmation3 = false;
    },

    saveInvestmentProof() {
      
      this.tempRecord.audited = true;
      this.tempRecord.approved = this.partialAmount;
      this.tempRecord.status = "approved";
      this.tempRecord.audit_remarks = this.comment;
      eventBus.$emit("saveInvestmentProof", this.tempRecord);
      this.showConfirmationMsg = false;
    },
     saveInvestmentProof2() {
      
      this.tempRecord.audited = true;
      this.tempRecord.approved = this.partialAmount;
      this.tempRecord.status = "approved";
      this.tempRecord.audit_remarks = this.comment;
      eventBus.$emit("saveInvestmentProof2", this.tempRecord);
      this.showConfirmationMsg2 = false;
    },
    saveInvestmentProof3() {

      this.tempRecord.approved = this.partialAmount;
      this.tempRecord.status = "approved";
      this.tempRecord.audit_remarks = this.comment;
      eventBus.$emit("saveInvestmentProof3", this.tempRecord,this.info);
      this.showConfirmationMsg3 = false;
    },

    saveRejectProof() {
      this.rejectData.audited = true;
      this.rejectData.approved = 0;
      this.rejectData.status = "rejected";
      this.rejectData.audit_remarks = this.comment;
      eventBus.$emit("saveRejectProof", this.rejectData);
      this.showRejectMsg = false;
    },
      saveRejectProof2() {
      this.rejectData.audited = true;
      this.rejectData.approved = 0;
      this.rejectData.status = "rejected";
      this.rejectData.audit_remarks = this.comment;
      eventBus.$emit("saveRejectProof2", this.rejectData);
      this.showRejectMsg2 = false;
    },
    saveRejectProof3() {
      
      this.tempRecord.approved = 0;
      this.tempRecord.status = "rejected";
      this.tempRecord.audit_remarks = this.comment;
      eventBus.$emit("saveRejectProof3", this.tempRecord,this.info);
      this.showRejectMsg3= false;
    },
    // Click on popup modal to open it.
    modalSection10(record) {
      this.showSection10Msg = true;

    },

    modalSection17(record) {
      this.showSection17Msg = true;
    },

    modalChapterVIA(record) {
      this.showChapterVIMsg = true;
    },

    closeIcon() {
      this.showSection10Msg = false;
      this.showSection17Msg = false;
      this.showChapterVIMsg = false;
    },

    /* function to hide the confimation pop-up */
    cancelEvent() {
      this.showConfirmationMsg = false;
      this.showConfirmationMsg2 = false;
      this.showConfirmationMsg3 = false;
      this.showRejectMsg = false;
      this.showRejectMsg2 = false;
      this.showRejectMsg3 = false;
    },

    selfoccupiedApprove(Self_occupied) {
      
      this.section24.self_occupied.status='approved'
      this.section24.self_occupied.approved=this.section24.self_occupied.total_actual;
      
      this.showApproveConfirmation2 = true;
    },

    selfoccupiedPartiallyApprove(Self_occupied) {
      
      this.ParticularName='Self Occupied Property'
      this.theAmount=this.section24.self_occupied.total_actual;
      this.tempRecord=this.self_occupied;
      this.showConfirmationMsg2 = true;

    },

    selfoccupiedReject(Self_occupied) {
      
      this.showRejectMsg = true;
    },

    letoutApprove(Letout) {
      
     // this.showApproveConfirmation = true;
    },

    letoutPartiallyApprove(Letout) {
      
      this.showConfirmationMsg = true;
    },

    letoutReject(Letout) {
      
      this.showRejectMsg = true;
    },

    peApprove(info) {
      
      this.info=info;
      if(info=='salary_income'){
        this.previousEmploymentDetails.salary_income.status='approved';
        this.previousEmploymentDetails.salary_income.approved=this.previousEmploymentDetails.salary_income.amount;
        this.tempRecord=this.previousEmploymentDetails.salary_income;
      }else if(info=='PT'){
        this.previousEmploymentDetails.pt.status='approved';
        this.previousEmploymentDetails.pt.approved=this.previousEmploymentDetails.pt.amount; 
        this.tempRecord=this.previousEmploymentDetails.pt;   
      }else if(info=='VPF'){
        this.previousEmploymentDetails.vpf.status='approved';
        this.previousEmploymentDetails.vpf.approved=this.previousEmploymentDetails.vpf.amount; 
        this.tempRecord=this.previousEmploymentDetails.vpf;
      }else if(info=='PF'){
        this.previousEmploymentDetails.pf.status='approved';
        this.previousEmploymentDetails.pf.approved=this.previousEmploymentDetails.pf.amount; 
        this.tempRecord=this.previousEmploymentDetails.pf;

      }else if(info=='NPS'){
        this.previousEmploymentDetails.nps.status='approved';
        this.previousEmploymentDetails.nps.approved=this.previousEmploymentDetails.nps.amount; 
        this.tempRecord=this.previousEmploymentDetails.nps;

      }else if(info=='TDS'){
        this.previousEmploymentDetails.tds.status='approved';
        this.previousEmploymentDetails.tds.approved=this.previousEmploymentDetails.tds.amount; 
        this.tempRecord=this.previousEmploymentDetails.tds;

      }else{
        //console.log("something is wrong !!!!");
      }
     this.showApproveConfirmation3 = true;
    },
    pePartiallyApprove(info) {
        this.info=info;
      if(info=='salary_income'){
        
        this.tempRecord=this.previousEmploymentDetails.salary_income;
        this.ParticularName = 'SALARY INCOME';
        this.theAmount = this.tempRecord.amount;        

      }else if(info=='PT'){
        this.tempRecord=this.previousEmploymentDetails.pt;
        this.ParticularName = 'PT';
        this.theAmount = this.tempRecord.amount;   
      }else if(info=='VPF'){
        this.tempRecord=this.previousEmploymentDetails.vpf;
        this.ParticularName = 'VPF';
        this.theAmount = this.tempRecord.amount;
      }else if(info=='PF'){
        this.tempRecord=this.previousEmploymentDetails.pf;
        this.ParticularName = 'PF';
        this.theAmount = this.tempRecord.amount;
      }else if(info=='NPS'){
        this.tempRecord=this.previousEmploymentDetails.nps;
        this.ParticularName = 'NPS';
        this.theAmount = this.tempRecord.amount;
      }else if(info=='TDS'){
        this.tempRecord=this.previousEmploymentDetails.tds;
        this.ParticularName = 'TDS';
        this.theAmount = this.tempRecord.amount;

      }else{
        //console.log("something is wrong !!!!");
      }
      this.showConfirmationMsg3 = true;
    },
    peReject(info) {
      this.info=info;
      if(info=='salary_income'){
        
        this.tempRecord=this.previousEmploymentDetails.salary_income;
        this.ParticularName = 'SALARY INCOME';
        this.theAmount = this.tempRecord.amount;        

      }else if(info=='PT'){
        this.tempRecord=this.previousEmploymentDetails.pt;
        this.ParticularName = 'PT';
        this.theAmount = this.tempRecord.amount;   
      }else if(info=='VPF'){
        this.tempRecord=this.previousEmploymentDetails.vpf;
        this.ParticularName = 'VPF';
        this.theAmount = this.tempRecord.amount;
      }else if(info=='PF'){
        this.tempRecord=this.previousEmploymentDetails.pf;
        this.ParticularName = 'PF';
        this.theAmount = this.tempRecord.amount;
      }else if(info=='NPS'){
        this.tempRecord=this.previousEmploymentDetails.nps;
        this.ParticularName = 'NPS';
        this.theAmount = this.tempRecord.amount;
      }else if(info=='TDS'){
        this.tempRecord=this.previousEmploymentDetails.tds;
        this.ParticularName = 'TDS';
        this.theAmount = this.tempRecord.amount;

      }else{
        //console.log("something is wrong !!!!");
      }
      this.showRejectMsg3 = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

.img-close {
  position: absolute;
  //transform: translate(238px, -10px);
  cursor: pointer;
  margin-left: 88%;
  margin-top: -22px;
}

.img-size-close {
  width: 15px;
}

.action-section {
  margin: 0px;
  text-align: center;
  img {
    width: auto;
  }
  .action-menu {
    top: 0px;
    right: 54px;
    left: -182px;
    li {
      padding: 0px;
      padding: 10px 25px;
      font-weight: 500;
      &:not(:last-child) {
        border-bottom: solid 1px #97979759;
      }
    }
  }
}

// modal css previous employer
a.arrow.arrow-prev {
  font-size: 25px;
  font-weight: 600;
  margin: 0 10px;
}
a.arrow.arrow-next {
  font-size: 25px;
  font-weight: 600;
  margin: 0 10px;
}
img.docImage {
  width: 370px;
}
.custom-modal .modal-content .modal-footer {
  width: 100%;
}
span.delete-download {
  margin: 0 20px;
}
.add-new-document {
  width: 161px;
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
  border: 1px solid #37c6c0;
  border-radius: 4px;
  padding: 14px;
}

// End here

.col-10-new {
  -ms-flex: 0 0 83.33334%;
  -webkit-box-flex: 0;
  flex: 0 0 83.33334%;
  max-width: 83.33334%;
}

.left-box-6 {
  padding: 25px;
  border-right-width: 0;
  border: 1px solid #c9c9c9;
  border-left-width: 0;
  border-top-width: 0;
}

.right-box-6 {
  padding: 25px;
  border: 1px solid #c9c9c9;
  border-right-width: 0;
  border-top-width: 0;
  border-left-width: 0;
}

.amount-right {
  text-align: right;
}

.side-hr-lr {
  border: 1px solid #c9c9c9;
  border-top-width: 0;
  border-bottom-width: 0;
  height: 55px;
}

.view-proof-title {
  text-align: center;
  padding: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
}

.view-proof-title-pointer {
  cursor: pointer;
}

.add-new-investment {
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
}

.add-new-investment-pointer {
  cursor: pointer;
}

.img-icon {
  transform: translate(-1px, 5px);
}

.atch-img {
  margin-right: 10px;
  transform: rotate(45deg);
}

.attachment-text {
  transform: translate(0px, 2px);
  position: absolute;
  font-size: 12px;
}

.othersection {
  padding: 15px 0px;
  background-color: #f2f2f2;
}

.img-icon-success {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.success-title-proof {
  font-size: 14px;
  font-weight: 600;
  position: absolute;
  margin-top: 5px;
}

.edit-investment-plan {
  position: relative;
  margin-top: 5px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #5d409f;
}

.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}
.center {
  margin: 500px;
}
.resize {
  margin-left: 100px;
}
.bold-text {
  width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}
.add-new {
  width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
.click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  // margin-left: -30px;
  margin-top: 10px;
}
.oval {
  // background-color: #ffa000;
  width: 75px;
  height: 75px;
  border-radius: 41px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight {
  height: 1px;
}

.img-user {
  margin: auto 0;
  text-align: center;
}

.month {
  margin-top: 8px;
  text-align: center;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.employee-code {
  margin-bottom: 18px;
  font-size: 13px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.salary-ctc {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.close-card {
  position: absolute;
  cursor: pointer;
  color: #5d409f;
  right: 10px;
  top: 4px;
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18%;
  width: 400px;
  text-align: center;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

#example {
  margin-top: 20px;
}

// #example .col-4 {
//   border: 1px solid #c9c9c9;
// }

// #example .col-4:not(:last-child) {
//   border-right-width: 0;
// }

#example .row:not(:last-child) .col-4 {
  border-bottom-width: 0;
}

#example .col-5 {
  border: 1px solid #c9c9c9;
}

#example .col-5:not(:last-child) {
  border-left-width: 0;
  border-right-width: 0;
}

// #example .row:not(:last-child) .col-5 {
//   border-bottom-width: 0;
// }

.first {
  height: 210px;
  padding: 32px;
  border-radius: 10px 0px 0px 10px;
  border: solid 1px #dddddd;
}

.middle {
  //max-width:37%;
  height: 210px;
  padding: 32px;
  // border-radius: 10px 0px 0px 10px;
  // border: solid 1px #dddddd;
}

.last {
  // max-width: 37%;
  // flex: 0 0 37%;
  height: 210px;
  //padding: 32px;
  border-radius: 0px 10px 10px 0px;
  border: solid 1px #dddddd;
  border-left-width: 0;
}

.regime-title {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.badget-custom {
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

.icon-i {
  // margin: 0px 12px;
  transform: translate(0px, 7px);
}

.total-taxable-income {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.taxable-amount {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  // margin-right: 20px;
  text-align: right;
}

.custom-width-block-19 {
  width: 14%;
}

.custom-width-block-13 {
  width: 13%;
}
.icon-move-right {
  float: right;
  margin-right: 7px;
}

.custom-col {
  margin-right: 0px;
}

.deduction-title {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.line {
  width: 1px;
  display: inline-block;
  height: 19px;
  margin: 0px 13px 0px 10px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.block-deductions {
  width: 404px;
  // height: 145px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  cursor: pointer;
}

.block-deductions-title {
  margin-bottom: 8px;
}

.block-deductions-sub-title {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.deduction-img {
  text-align: right;
  transform: translate(0px, 0px);
}

.amount-deduction {
  text-align: right;
  display: block;
}

.progress-bar-blue {
  margin-top: 10px;
  width: 340px;
  border-radius: 10px;
  height: 10px;
  background-color: #dadada;
}

.progress-target {
  background-color: #34c0be;
  border-radius: 10px;
  height: 10px;
  width: 94px;
}

.progress-target-full {
  background-color: #34c0be;
  border-radius: 10px;
  height: 10px;
  width: 340px;
}

.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // background-color: rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(10px);
}

/* For all Section 10,17, 80C popup */
.modal-content-section {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 40%;
  // height: 191px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  opacity: 0;
  padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  // -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}

/* Modal Content */

.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 30%;
  // height: 191px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  opacity: 0;
  padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  // -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;

  .success-icon {
    // margin-bottom: 40px;
  }

  .success-text {
    font-size: $font-size-l1;
    font-weight: 600;
    // margin-bottom: auto;
    margin-left: 12px;
    color: #6e6e6e;
  }

  .message-text {
    font-size: $font-size-l1;
    margin-bottom: 20px;
    line-height: 25px;
    animation-delay: 0.7s;
    animation-name: fadeInRight;
    -webkit-animation-name: fadeInRight;
  }
  .btn-confirm-delete {
    display: flex;
    align-items: center;
    *:nth-child(n) {
      margin-right: 20px;
    }
  }
  .warning {
    margin-bottom: 16px;
    text-align: center;
    height: 24px;
    width: 24px;
  }
  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: $color-primary;
    color: $color-white;
  }
  .btn-popup-secondary {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: #ffffff;
    border: #34c0be solid 2px;
    color: #34c0be;
  }

  .close-btn {
    position: relative;
    transform: scale(2);
    left: 230px;
    bottom: 20px;
    cursor: pointer;
  }
}
.success-img {
  position: relative;
  height: 24px;
  width: 24px;
  &.animated {
    animation-name: pulse;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: pulse;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}
.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
@keyframes showPopup {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showc {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showt {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }
  100% {
    padding-left: 0px;
    opacity: 1;
  }
}
@-webkit-keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }
  100% {
    padding-left: 0px;
    opacity: 1;
  }
}
.popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }
}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }
  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }
  10% {
    transform: scale3d(1, 1, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
@-webkit-keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }
  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }
  10% {
    transform: scale3d(1, 1, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}

@keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }
  10% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@-webkit-keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }
  10% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
.top-bar {
  height: 64px;
  // width: 100%;
  width: 453px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 24px;
}

.heading_new {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}
</style>
